import {
    User,
    Shield,
    Layers,
    MapPin,
    Landmark,
    Users,
    AppWindow,
    FileText,
    Wallet,
} from "lucide-react";
import type { LucideIcon } from "lucide-react";

// ─── Step Definition ─────────────────────────────────────────────────────────
export interface OnboardStep {
    /** Tab key used by the Tabs component (e.g. "tab1") */
    tabKey: string;
    /** Unique identifier sent to backend in onboardingProcess[] */
    stepId: string;
    /** Human-readable label for the tab */
    label: string;
    /** Lucide icon component */
    icon: LucideIcon;
}

// ─── All 9 onboarding steps in order ────────────────────────────────────────
export const ONBOARD_STEPS: OnboardStep[] = [
    { tabKey: "tab1", stepId: "basic_details",   label: "Basic Details",   icon: User },
    { tabKey: "tab2", stepId: "permissions",     label: "Permissions",     icon: Shield },
    { tabKey: "tab3", stepId: "application",     label: "Application",     icon: AppWindow },
    { tabKey: "tab4", stepId: "advance_details", label: "Advance Details", icon: Layers },
    { tabKey: "tab5", stepId: "address",         label: "Address",         icon: MapPin },
    { tabKey: "tab6", stepId: "bank_details",    label: "Bank Details",    icon: Landmark },
    { tabKey: "tab7", stepId: "nominee",         label: "Nominee",         icon: Users },
    { tabKey: "tab8", stepId: "documents",       label: "Documents",       icon: FileText },
    { tabKey: "tab9", stepId: "salary_detail",   label: "Salary Detail",   icon: Wallet },
];

export const TOTAL_STEPS = ONBOARD_STEPS.length; // 9
